/**
 * @file IconExpressionSmile Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-expression-smile',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 200 200">
  <defs>
    <clipPath><rect width="200" height="200" x="0" y="0" rx="0" /></clipPath>
  </defs>
  <g clip-path="url(#master_svg0_30_6862)">
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        d="M100,10C149.706,10,190,50.2944,190,100C190,149.706,149.706,190,100,190C50.2944,190,10,149.706,10,100C10,50.2944,50.2944,10,100,10ZM100,20C55.8172,20,20,55.8172,20,100C20,144.183,55.8172,180,100,180C144.183,180,180,144.183,180,100C180,55.8172,144.183,20,100,20ZM150,110C150,137.614,127.614,160,100,160C72.3858,160,50,137.614,50,110L150,110ZM65,60C73.2843,60,80,66.7157,80,75C80,83.2843,73.2843,90,65,90C56.7157,90,50,83.2843,50,75C50,66.7157,56.7157,60,65,60ZM135,60C143.284,60,150,66.7157,150,75C150,83.2843,143.284,90,135,90C126.716,90,120,83.2843,120,75C120,66.7157,126.716,60,135,60Z"
      />
    </g>
  </g>
</svg>
`
);
